import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';
import { MarginWrapper } from '../../layouts/margin-wrapper';

@Component({
  selector: 'allas-sobre-nosotros',
  imports: [MainLayout, MarginWrapper],
  template: `
    <allas-main-layout [showPopularSections]="true" [showNewsletter]="true">
      <allas-margin-wrapper styleClass="fs-condensed">
        <!-- Hero Section -->
        <main class="flex flex-col md:flex-row gap-2 w-full my-3 md:my-6">
          <section
            class="mx-auto max-w-[90ch] text-pretty px-4 text-left text-base md:text-xl md:px-6 lg:px-20 leading-relaxed md:leading-loose order-1 md:order-none"
          >
            <h1
              class="mx-auto mb-6 md:mb-10 text-wrap pt-6 md:pt-10 text-center text-2xl md:text-4xl font-semibold tracking-wide px-2"
            >
              ¿Como nace <b class="text-appPrimary-500">Allas Repuestos</b>?
            </h1>

            <p class="text-pretty mb-4 md:mb-0">
              Nacimos en la ciudad de
              <strong class="text-allasRed">La Ceiba, Honduras</strong>, en
              Julio de 1984 como una empresa familiar y bajo el nombre legal de
              <strong class="text-allasRed">
                Llanticentro Ceibeño S. de R.L.
              </strong>
              <br />
              En su inicio nos dedicamos a la venta, armado y balanceo de
              llantas y alineamiento de vehículos utilizando la tecnología de
              punta que existía en aquella época.
            </p>
            <br class="hidden md:block" />
            <p class="text-pretty mb-4 md:mb-0">
              En <strong class="text-allasRed">1989</strong> y producto de
              nuestra visión de ayudar a que las personas y bienes se trasladen
              de un lugar a otro de forma segura tomamos la decisión de
              incorporar la línea de repuestos de excelente calidad, decisión
              que ha sido nuestra
              <strong class="text-allasRed"> razón de existir.</strong>
            </p>
            <br class="hidden md:block" />
            <p class="text-pretty">
              En Abril de 2002 se inicia la expansión de
              <strong class="text-allasRed">Allas Repuestos</strong> y se
              construye un moderno edificio en la ciudad de
              <strong class="text-allasRed">San Pedro Sula</strong>, donde se
              instala una tienda de repuestos, el centro de distribución y las
              oficinas administrativas.
              <br />
              Al día de hoy contamos con 12 tiendas ubicadas en las principales
              ciudades del país y las cuales se caracterizan por tener un amplio
              surtido de repuestos de excelente calidad, personal capacitado y
              procesos innovadores que nos permiten satisfacer las necesidades
              de nuestros clientes y ser líderes en el mercado.
            </p>
          </section>
          <section
            class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-3 md:gap-2 order-2 md:order-none mt-4 md:mt-0"
          >
            <img
              src="/images/stores/04.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
            <img
              src="/images/stores/05.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
            <img
              src="/images/stores/12.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
            <img
              src="/images/stores/13.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
            <img
              src="/images/stores/07.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
            <img
              src="/images/stores/14.webp"
              alt="Sucursal Principal"
              class="w-full h-48 sm:h-56 md:h-full object-cover rounded-md shadow-md"
            />
          </section>
        </main>
      </allas-margin-wrapper>
    </allas-main-layout>
  `,
})
export class SobreNosotros implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Sobre Nosotros | Allas Repuestos';
    const description =
      'Conoce la historia de Allas Repuestos desde 1984. Empresa familiar hondureña con 12 tiendas especializada en repuestos de calidad y servicios automotrices.';
    const keywords =
      'repuestos, Allas Repuestos, Honduras, La Ceiba, San Pedro Sula, empresa familiar, repuestos automotrices, calidad, garantía, envío a domicilio';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
